// extracted by mini-css-extract-plugin
module.exports = {"hiddenOverflow":"Layout_hiddenOverflow__Oc_vW","darkBackground":"Layout_darkBackground__J31_s"};